import { ElementRef, Injectable } from '@angular/core';
import { Subject, first, filter } from 'rxjs';
import { DropdownLayoutComponent } from './dropdown-layout.component';
import { DropdownComponent } from './dropdown.component';
import { DropdownContent, DropdownOptions } from './model';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {

  private _layout?: DropdownLayoutComponent
  private _activeDropdown?: DropdownComponent
  private _activeDropdownSubject = new Subject<DropdownComponent|undefined>()

  get layout() {
    if (this._layout) {
      return this._layout
    }
    throw new Error('DropdownLayoutComponent not exists')
  }

  get activeDropdown() {
    return this._activeDropdown
  }

  private set activeDropdown(comp: DropdownComponent|undefined) {
    this._activeDropdown = comp
    this._activeDropdownSubject.next(comp)
  }

  registerLayout(comp: DropdownLayoutComponent) {
    if (this._layout) {
      throw new Error('DropdownLayoutComponent already exists')
    }
    this._layout = comp
  }

  registerDropdown(comp: DropdownComponent) {
    this.activeDropdown = comp
    comp.events$.subscribe({complete: () => this.activeDropdown = undefined})
  }

  create(content: DropdownContent, positionHost: HTMLElement|ElementRef<HTMLElement>, options?: Partial<DropdownOptions>) {
    setTimeout(() => this.layout.create(content, positionHost, options), 0)
    return this._activeDropdownSubject.pipe(
      filter(d => d != undefined),
      first()
    )
  }

  destroy() {
    this.layout.destroy()
  }

}
